/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GlossaryFileSupportResponse,
  SmartProblemDetails,
} from '../models/index';
import {
    GlossaryFileSupportResponseFromJSON,
    GlossaryFileSupportResponseToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface GlossariesDeleteGlossaryFileRequest {
    glossaryId: string;
}

export interface GlossariesDownloadGlossaryFileGetRequest {
    glossaryId: string;
}

export interface GlossariesUpdateGlossaryMetadataPostRequest {
    glossaryId?: string;
    glossaryName?: string;
    glossaryDescription?: string;
}

export interface GlossariesUpsertGlossaryPostRequest {
    glossaryId?: string;
    glossaryName?: string;
    glossaryDescription?: string;
    uploadedFile?: Blob;
}

/**
 * 
 */
export class GlossariesApi extends runtime.BaseAPI {

    /**
     */
    async glossariesDeleteGlossaryFileRaw(requestParameters: GlossariesDeleteGlossaryFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['glossaryId'] == null) {
            throw new runtime.RequiredError(
                'glossaryId',
                'Required parameter "glossaryId" was null or undefined when calling glossariesDeleteGlossaryFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Glossaries/{glossaryId}`;
        urlPath = urlPath.replace(`{${"glossaryId"}}`, encodeURIComponent(String(requestParameters['glossaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async glossariesDeleteGlossaryFile(requestParameters: GlossariesDeleteGlossaryFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.glossariesDeleteGlossaryFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async glossariesDownloadGlossaryFileGetRaw(requestParameters: GlossariesDownloadGlossaryFileGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['glossaryId'] == null) {
            throw new runtime.RequiredError(
                'glossaryId',
                'Required parameter "glossaryId" was null or undefined when calling glossariesDownloadGlossaryFileGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Glossaries/{glossaryId}`;
        urlPath = urlPath.replace(`{${"glossaryId"}}`, encodeURIComponent(String(requestParameters['glossaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async glossariesDownloadGlossaryFileGet(requestParameters: GlossariesDownloadGlossaryFileGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.glossariesDownloadGlossaryFileGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async glossariesGetGlossaryFileSupportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlossaryFileSupportResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Glossaries/supports`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlossaryFileSupportResponseFromJSON(jsonValue));
    }

    /**
     */
    async glossariesGetGlossaryFileSupport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlossaryFileSupportResponse> {
        const response = await this.glossariesGetGlossaryFileSupportRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async glossariesUpdateGlossaryMetadataPostRaw(requestParameters: GlossariesUpdateGlossaryMetadataPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['glossaryId'] != null) {
            headerParameters['glossaryId'] = String(requestParameters['glossaryId']);
        }

        if (requestParameters['glossaryName'] != null) {
            headerParameters['glossaryName'] = String(requestParameters['glossaryName']);
        }

        if (requestParameters['glossaryDescription'] != null) {
            headerParameters['glossaryDescription'] = String(requestParameters['glossaryDescription']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Glossaries/metadata`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async glossariesUpdateGlossaryMetadataPost(requestParameters: GlossariesUpdateGlossaryMetadataPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.glossariesUpdateGlossaryMetadataPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async glossariesUpsertGlossaryPostRaw(requestParameters: GlossariesUpsertGlossaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['glossaryId'] != null) {
            headerParameters['glossaryId'] = String(requestParameters['glossaryId']);
        }

        if (requestParameters['glossaryName'] != null) {
            headerParameters['glossaryName'] = String(requestParameters['glossaryName']);
        }

        if (requestParameters['glossaryDescription'] != null) {
            headerParameters['glossaryDescription'] = String(requestParameters['glossaryDescription']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['uploadedFile'] != null) {
            formParams.append('uploadedFile', requestParameters['uploadedFile'] as any);
        }


        let urlPath = `/api/Glossaries`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async glossariesUpsertGlossaryPost(requestParameters: GlossariesUpsertGlossaryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.glossariesUpsertGlossaryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
